import React from "react";

const CheckIcon = React.forwardRef(
    function CheckIcon(
        {
            title,
            titleId,
            ...props
        },
        svgRef
    ) {
        return (
            <svg
                viewBox="0 0 20 20"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                ref={svgRef}
                aria-labelledby={titleId}
                fill="none"
                stroke="none"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-eye-off"
                {...props}
            >
                {title ? <title id={titleId}>{title}</title> : null}
                <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#D5D7DA"/>
                <path d="M6.25 10L8.75 12.5L13.75 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        );
    }
);

export default CheckIcon;
